import './App.css';
import Sidebar from './components/sidebar/Sidebar';
import Navbar from "./components/navbar/Navbar"
import GraphOne from './components/dashbordcard/GraphOne';
import ExpencesChat from './components/exp/ExpencesChat';
import TotalAss from "./components/exp/totalAss/TotalAss";
import IncidentM from './components/exp/incidentM/IncidentM';
import Department from "./components/thirdRow/dept/Department"
import DownTime from './components/thirdRow/downtime/DownTime';
import Calibrated from './components/forthrow/cali/Calibrated';
import Manual from './components/forthrow/manual/Manual';

function App() {
  return (
    <div className="App">
      <Sidebar />
      <Navbar />
      <GraphOne />
      <ExpencesChat />
      <TotalAss />
      <IncidentM />
      <Department />
      <DownTime />
      <Calibrated />
      <Manual />
    </div>
  );
}

export default App;
